export enum ConnectionsContextActionTypes {
  SetFormState = 'form/SET_CONNECTIONS_FORM_STATE',
  SetCompanyId = 'connection/SET_COMPANY_ID',
  NavigateToPath = 'connection/NAVIGATE_PATH',
  PushToPath = 'connection/PUSH_PATH',
  SetFormIndeterminate = 'form/SET_CONNECTIONS_FORM_INDETERMINATE',
  SetConnectionsCounts = 'connection/SET_CONNECTIONS_COUNT',
}

export interface ConnectionsFromInterface {
  companies: { value: boolean; indeterminate: boolean };
  branches: { value: boolean; indeterminate: boolean };
  persons: { value: boolean; indeterminate: boolean };
  phone: { value: boolean; indeterminate: boolean };
  email: { value: boolean; indeterminate: boolean };
  address: { value: boolean; indeterminate: boolean };
  website: { value: boolean; indeterminate: boolean };
  historicalType: { value: boolean; indeterminate: boolean };
  shareholder: { value: boolean; indeterminate: boolean };
  beneficialOwner: { value: boolean; indeterminate: boolean };
  administrator: { value: boolean; indeterminate: boolean };
  auditor: { value: boolean; indeterminate: boolean };
  memberOfTheBoard: { value: boolean; indeterminate: boolean };
  branchManager: { value: boolean; indeterminate: boolean };
  empoweredToSign: { value: boolean; indeterminate: boolean };
  founder: { value: boolean; indeterminate: boolean };
  liablePartner: { value: boolean; indeterminate: boolean };
  generalAgent: { value: boolean; indeterminate: boolean };
  liquidator: { value: boolean; indeterminate: boolean };
  management: { value: boolean; indeterminate: boolean };
  other: { value: boolean; indeterminate: boolean };
  memberOfSupervisoryBoard: { value: boolean; indeterminate: boolean };
}

export interface ConnectionsIndeterminateInterface {
  companies: boolean;
  branches: boolean;
  persons: boolean;
  phone: boolean;
  email: boolean;
  address: boolean;
  website: boolean;
  shareholder: boolean;
  beneficialOwner: boolean;
  administrator: boolean;
  auditor: boolean;
  memberOfTheBoard: boolean;
  branchManager: boolean;
  empoweredToSign: boolean;
  founder: boolean;
  liablePartner: boolean;
  generalAgent: boolean;
  liquidator: boolean;
  management: boolean;
  other: boolean;
  memberOfSupervisoryBoard: boolean;
}

export interface ConnectionsCounts {
  total: number;
  displayed: number;
}

export interface Path {
  id: string;
  name: string;
}

export type ConnectionsContextActions =
  | { type: ConnectionsContextActionTypes.SetFormState; payload: ConnectionsFromInterface }
  | { type: ConnectionsContextActionTypes.SetCompanyId; payload: string }
  | { type: ConnectionsContextActionTypes.PushToPath; payload: Path }
  | { type: ConnectionsContextActionTypes.NavigateToPath; payload: number }
  | {
      type: ConnectionsContextActionTypes.SetFormIndeterminate;
      payload: ConnectionsIndeterminateInterface;
    }
  | { type: ConnectionsContextActionTypes.SetConnectionsCounts; payload: ConnectionsCounts };

export type ConnectionsProps = {
  form: ConnectionsFromInterface;
  formIndeterminate: ConnectionsIndeterminateInterface;
  companyId: string;
  path: Path[];
  connectionsCounts: ConnectionsCounts;
};

export type ConnectionsProviderProps = { children: React.ReactNode };
